import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
    Container,
    Paper,
    Stack,
    Text,
    Title,
    Loader,
    Center,
    Badge
} from "@mantine/core";

type ParkingQrValidationDto = {
    isValid: boolean;
    message?: string;
    eventName?: string;
    validDate?: string;
    usedAt?: string;
};

export default function ParkingQrValidationPage() {
    const apiUrl = process.env.REACT_APP_API_URL;
    const { token } = useParams();

    const [loading, setLoading] = useState(true);
    const [data, setData] = useState<ParkingQrValidationDto | null>(null);

    useEffect(() => {
        validateQr();
    }, [token]);

    async function validateQr() {
        if (!apiUrl || !token) {
            setLoading(false);
            return;
        }

        setLoading(true);

        try {
            const res = await fetch(`${apiUrl}/api/parking/qr/validate/${token}`, {
                method: "POST"
            });

            const json = await res.json();
            setData(json);
        } catch {
            setData({
                isValid: false,
                message: "Could not validate QR code."
            });
        } finally {
            setLoading(false);
        }
    }

    const isValid = data?.isValid;

    return (
        <Container size="sm" py="xl">
            <Paper
                withBorder
                p="xl"
                radius="lg"
                style={{
                    backgroundColor: loading
                        ? "#f8f9fa"
                        : isValid
                            ? "#d3f9d8"
                            : "#ffe3e3"
                }}
            >
                {loading ? (
                    <Center>
                        <Stack align="center">
                            <Loader color="red" />
                            <Text>Checking QR code...</Text>
                        </Stack>
                    </Center>
                ) : isValid ? (
                    <Stack align="center" gap="md">
                        <Badge color="green" size="xl" variant="filled">
                            VALID
                        </Badge>

                        <Title order={2} ta="center">
                            ACCESS APPROVED
                        </Title>

                        <Text c="dimmed">
                            {data?.eventName}
                        </Text>

                        {data?.message && (
                            <Text ta="center">{data.message}</Text>
                        )}
                    </Stack>
                ) : (
                    <Stack align="center" gap="md">
                        <Badge color="red" size="xl" variant="filled">
                            DENIED
                        </Badge>

                        <Title order={2} ta="center">
                            ACCESS DENIED
                        </Title>

                        <Text ta="center" fw={500}>
                            {data?.message || "QR code is not valid."}
                        </Text>

                        {data?.eventName && (
                            <Text ta="center">{data.eventName}</Text>
                        )}
                    </Stack>
                )}
            </Paper>
        </Container>
    );
}